import React from "react";

const PersonIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="person_icon"
      data-name="person"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1.66663C9.17591 1.66663 8.37033 1.911 7.68512 2.36884C6.99992 2.82668 6.46587 3.47742 6.1505 4.23878C5.83514 5.00014 5.75262 5.83791 5.91339 6.64617C6.07417 7.45442 6.471 8.19685 7.05372 8.77957C7.63644 9.36229 8.37887 9.75913 9.18712 9.9199C9.99538 10.0807 10.8332 9.99816 11.5945 9.68279C12.3559 9.36743 13.0066 8.83337 13.4645 8.14817C13.9223 7.46296 14.1667 6.65738 14.1667 5.83329C14.1667 4.72822 13.7277 3.66842 12.9463 2.88701C12.1649 2.10561 11.1051 1.66663 10 1.66663ZM10 8.33329C9.50555 8.33329 9.0222 8.18667 8.61107 7.91197C8.19995 7.63726 7.87952 7.24682 7.6903 6.79C7.50108 6.33319 7.45157 5.83052 7.54804 5.34557C7.6445 4.86061 7.8826 4.41516 8.23223 4.06553C8.58186 3.71589 9.02732 3.47779 9.51227 3.38133C9.99723 3.28487 10.4999 3.33437 10.9567 3.52359C11.4135 3.71281 11.804 4.03324 12.0787 4.44437C12.3534 4.85549 12.5 5.33884 12.5 5.83329C12.5 6.49633 12.2366 7.13222 11.7678 7.60106C11.2989 8.0699 10.663 8.33329 10 8.33329ZM17.5 17.5V16.6666C17.5 15.1195 16.8854 13.6358 15.7915 12.5418C14.6975 11.4479 13.2138 10.8333 11.6667 10.8333H8.33333C6.78624 10.8333 5.30251 11.4479 4.20854 12.5418C3.11458 13.6358 2.5 15.1195 2.5 16.6666V17.5H4.16667V16.6666C4.16667 15.5616 4.60565 14.5017 5.38705 13.7203C6.16846 12.9389 7.22826 12.5 8.33333 12.5H11.6667C12.7717 12.5 13.8315 12.9389 14.6129 13.7203C15.3943 14.5017 15.8333 15.5616 15.8333 16.6666V17.5H17.5Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default PersonIcon;
